/**
 * Monthly Collections report (IPD-MVP discharge-mis, BUILD-PLAN-fast-slice-v2
 * §7.0 frozen contract). Two NEW permission slugs — NOT tied to
 * `useAdmissionEnabled()`, NOT tied to any role. FE mirrors the backend
 * `ClinicPermission` enum so no surface ever inlines the literal string.
 */
export const MONTHLY_COLLECTIONS_PERMISSIONS = {
  VIEW_MONTHLY_COLLECTIONS: 'VIEW_MONTHLY_COLLECTIONS',
  EXPORT_MONTHLY_COLLECTIONS: 'EXPORT_MONTHLY_COLLECTIONS',
};

/**
 * Busy monthly files (BUSY-VOUCHER R3, OR-84): their OWN permission, separate
 * from the Reports & Accounts ones above. Gates the "Monthly files" section,
 * the Busy file download and the "How to import into Busy" guide (server-
 * enforced too). Mirrors the backend `ClinicPermission.DOWNLOAD_BUSY_FILES`
 * (ADMIN + ACCOUNTANT by default); arrives in the session permissions array.
 */
export const BUSY_FILES_PERMISSIONS = {
  DOWNLOAD_BUSY_FILES: 'DOWNLOAD_BUSY_FILES',
};
